import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { KeyInitiativeEditor } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/lpKeyInitiatives/components/keyInitiativeEditor/KeyInitiativeEditor'
import { selectPartnerAccess } from 'legacy/lut/features/partner360/configuration'
import {
  CommitmentReminderActionTypeEnum,
  ICommitmentReminderActionItem,
} from 'legacy/lut/services/partner360/commitment/models/ICommitmentReminder'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  normalizePlanReviewActionParams,
  resolvePlanReviewKeyObjectiveActionParam,
} from 'partner360/lib/planReviewActionParams'

interface IPlanReviewKeyInitiativeProps {
  selectedAction: ICommitmentReminderActionItem | null
  partnerId: string
  programType: ProgramTypes
  fyear: number
  onClose: () => void
  onConfirmed?: () => void | Promise<void>
}

export const PlanReviewKeyInitiative = ({
  selectedAction,
  onClose,
  onConfirmed,
  programType,
  partnerId,
  fyear,
}: IPlanReviewKeyInitiativeProps) => {
  const { isCommercial } = useSelector(selectPartnerAccess)

  const initialState = useMemo(() => {
    const actionParams = normalizePlanReviewActionParams(selectedAction?.ActionParam)
    const keyObjective = resolvePlanReviewKeyObjectiveActionParam(actionParams)

    if (keyObjective) {
      return { Development: keyObjective }
    }

    return undefined
  }, [selectedAction?.ActionParam])

  if (selectedAction?.ActionType !== CommitmentReminderActionTypeEnum.JBPPatInitiative) {
    return null
  }

  return (
    <KeyInitiativeEditor
      initialState={initialState}
      isDialogOpened={
        selectedAction?.ActionType === CommitmentReminderActionTypeEnum.JBPPatInitiative
      }
      isDataInsightPresent={false}
      partnerIdOverride={partnerId}
      fYearOverride={fyear}
      programTypeOverride={programType}
      isCommercialOverride={isCommercial}
      onEditCancel={onClose}
      onUpdateFinished={async () => {
        onConfirmed?.()
      }}
    />
  )
}
